enum ActionTypes {
	EditTournamentInfo = "Tournament.EditTournamentInfo",
	AddPlayers = "Tournament.AddPlayers",
	AddSeatingTemplate = "Tournament.AddSeatingTemplate",
	AddTables = "TournamentAddTables",
	AddGames = "Tournament.AddGames",
	SetTournament = "Tournament.SetTournament"
};

export default ActionTypes;